/**
 * تمييز الوسائط حسب امتداد الملفّ.
 * يُستخدم في HeroMedia ولوحة /admin/hero-media لاختيار طريقة العرض الصحيحة.
 */
export type MediaKind = "video" | "image" | "unknown";

export function detectMediaKind(url: string | undefined | null): MediaKind {
  if (!url) return "unknown";
  const clean = url.split("?")[0].toLowerCase();
  if (/\.(mp4|webm|mov|m4v)$/i.test(clean)) return "video";
  if (/\.(jpe?g|png|webp|avif|gif)$/i.test(clean)) return "image";
  return "unknown";
}
